import styles from "./breadcrumb.module.css";

type BreadcrumbItem = {
  label: string;
  href?: string;
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
};

export function Breadcrumb({ items }: Readonly<BreadcrumbProps>) {
  return (
    <nav className={styles.breadcrumb} aria-label="Breadcrumb" data-testid="breadcrumb">
      <ol className={styles.list}>
        {items.map((item, index) => (
          <li key={item.label} className={styles.item}>
            {index > 0 && <span className={styles.separator}>&gt;</span>}
            {item.href ? (
              <a href={item.href} className={styles.link}>{item.label}</a>
            ) : (
              <span className={styles.current}>{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
